import { useAuthStore } from '@/store/useAuthStore';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const fetchData = async (
    q: string,
    t: string | undefined,
    // apiUrl: string,
    sessionId: string,
    licenceId: string,
    phone: string
) => {
    const response = await axios.post(
        `https://w-ord.ntelgnt.com/proxy.php`,
        { q },
        {
            headers: { 'Content-Type': 'application/json' },
            params: {
                api: 'itqan',
                t,
                phone: phone,
                id: licenceId,
                s: sessionId,
                btn: 'w_itm'
            },
        }
    );
    return response.data;
}

const UseData = ({ q, dependency, t, skip = false }: {
    q?: string,
    dependency?: (string | number | undefined)[],
    t?: string,
    skip?: boolean
}) => {
    const navigate = useNavigate();
    const phone = useAuthStore((state) => state.user)?.phone || '';
    const sessionId = useAuthStore((state) => state.sessionId) || '';
    const licenceId = useAuthStore((state) => state.licenceId) || '';

    return useQuery({
        queryKey: ['data', q, t, sessionId, licenceId, phone, ...dependency ?? []],
        queryFn: async () => {
            const data = await fetchData(q!, t, sessionId, licenceId, phone);
            if (licenceId && data?.status === 'error' && data?.code === 'UNAUTHORIZED_TOKEN') {
                void navigate('/unauthorized', { replace: true });
                return null;
            }
            return data;
        },
        enabled: !skip && !!q && q.trim() !== '',
        retry: 1,
        staleTime: 0,
        refetchOnMount: true,
        placeholderData: (prev: any) => prev,
    });
};

export { UseData };